

    import React,{Component} from 'react';
	import Issueloopcomponent from './issueLoopComponent';
	import Orgsloopcomponent from './orgsLoopComponent';
	import Usersloopcomponent from './usersLoopComponent';
	import {Link} from 'react-router-dom';
	import axios from "axios";
	
	
	class dashboardComponent extends Component{
	
		constructor(props)
		{
			super(props)
			
			this.state = {
				firstName: null,
				lastName: null,
				middleName: null,
				githubUsername: null,
				userImage: null,
				imageString: null,
				imageState: null,
				issueName: null,
				issueState: null,
				issueProgLang: null,
				typeName: null,
				type: null,
				usersPayload: [],
				issuesPayload: [],
				orgsPayload: [],
				usersPayloadLinks: [],
				issuesPayloadLinks: [],
				orgsPayloadLinks: [],
				loading:true,
				emailVerificationStatus: false
			}
			
            this.handleClick = this.handleClick.bind(this);
            //this.submitHandler = this.submitHandler.bind(this);
           // this.changeHandler = this.changeHandler.bind(this);
			this.changeImage = this.changeImage.bind(this);
			this.handleProgLang = this.handleProgLang.bind(this);
			this.handleIssueName = this.handleIssueName.bind(this);
			this.handleIssueState = this.handleIssueState.bind(this);
			this.handleSaveIssue = this.handleSaveIssue.bind(this);
			this.deleteUser = this.deleteUser.bind(this); 
			this.handleTypeName = this.handleTypeName.bind(this); 
			this.handleType = this.handleType.bind(this); 
			this.handleTypeSubmit = this.handleTypeSubmit.bind(this); 
			this.showUsers = this.showUsers.bind(this);
			this.showIssues = this.showIssues.bind(this);
			this.showOrgs = this.showOrgs.bind(this);

			this.nextOrgs = this.nextOrgs.bind(this);
			this.prevOrgs = this.prevOrgs.bind(this);

			this.prevIssue = this.prevIssue.bind(this);
			this.nextIssue = this.nextIssue.bind(this);

			this.prevUsers = this.prevUsers.bind(this);
			this.nextUsers = this.nextUsers.bind(this);
			this.logOut = this.logOut.bind(this);
 
		}

		async handleClick()
		{
			// 
			//get user access token
			let token = localStorage.getItem("token");
					
			if((token === "noToken") || (token === null))
			{
			alert("Ilegal page view");
			 this.props.history.push("/gitsearch/");
			}


			this.setState({loading:true});

			//make axios call to api
			try{
					let userDataResponse = await axios({
					method: "get",
					url: "http://mofehintolumumuni.com/gitserver/api/users/email/verification/linkresend",
					headers: {"Authorization": "Bearer "+token}
					});
	
					let requestStatus = userDataResponse.data.status;
					//let VerifyMailSentStatus = userDataResponse.data.VerifyMailSentStatus;
					let message = userDataResponse.data.message;
	
					if(requestStatus === "success")
					{
						this.setState({loading:false});
						alert(message);
					
					}
					else{
						this.setState({loading:false});
						alert(message);
					}
			}
			catch(error)
			{
				this.setState({loading:false});
				alert("Action not successful try again!");

			}
			

		}

		async componentDidUpdate()
		{
			
		}
		

      
       async componentDidMount()
        {
            try
  			{
					//get user access token
					let token = localStorage.getItem("token");
						//alert(token);
					if((token === "noToken") || (token === null))
					{
					alert("Ilegal page view");
					this.props.history.push("/gitsearch/");
					}

					let userDataResponse = await axios({
					method: "get",
					url: "http://mofehintolumumuni.com/gitserver/api/users/profile",
					headers: {"Authorization": "Bearer "+token}
					});

					let requestStatus = userDataResponse.data.status;
					let payload = userDataResponse.data.data

					if(requestStatus === "success")
					{

					//alert(payload);
					//alert(JSON.stringify(payload));
					this.setState({firstName: payload['first_name']});
					this.setState({lastName: payload['last_name']});
					this.setState({middleName: payload['middle_name']});
					this.setState({userImage: payload['user_avatar']});

					if(payload['verify_email_status'] === "VERIFIED")
					{
						this.setState({emailVerificationStatus: true});
					}
					//this.setState({githubUsername: null});
					//fire users endpoint and hydrate state
					this.showUsers();
					//alert(payload['user_avatar']);
					}
					else{
					//redirect away from dashboard
					this.props.history.push("/gitsearch/");
					}

				}
				catch(error)
				{
					alert("User data not available please refresh page."+error);
					this.props.history.push("/gitsearch/");
				}

		
        }


        changeImage(e)
        {
		   
			this.setState({loading:true});
			
            let file = e.target.files;
            let reader = new FileReader();
            reader.readAsDataURL(file[0]);
            reader.onload = async (e) => {
              
			   // this.setState({imageString: e.target.result});
			   
			   let token = localStorage.getItem("token");

			   //this.setState({loading:true});
			   
			   if((null !== e.target.result) && ("" !== e.target.result))
			   {
			
				   //make axios call to api
				   try
				   {
					   
					   let imageString = e.target.result;
					 
					   let response = await axios({
						   method: "post",
						   url: "http://mofehintolumumuni.com/gitserver/api/users/profile/images/upload",
						   data: {photo: imageString},
						   headers: {"Authorization": "Bearer "+token}
						  
						   // "Content-Type": "application/x-www-form-urlencoded"
						   });
						   
						   //salert(JSON.stringify(response)); 

						   //alert(JSON.stringify(token)); 

						   let status = response.data.status;
						 //  let data = response.data.data;
   
						   if(status === "success")
						   {
							  this.setState({userImage:  response.data.data["image"]});
							 // alert(JSON.stringify(response.data.data["image"])); 
							  this.setState({loading:false});
							   alert("Image uploaded successfully!");
							   
						   }
						   else
						   {
							   alert("Image upload error!");
							   this.setState({loading:false});
						   }
   
				   }catch(error)
				   {
					
					   alert("Image upload error!"+error.message);
					   //alert(response.data.data);
					   this.setState({loading:false});
				   }
				   
			   }
			   else
			   {
				   alert("Select an image before uploading!");
				   this.setState({loading:false});
			   }

			}
			
			//alert(this.state.imageString);

		
       
		}
		
	 async uploadImage(e)
        {
			e.preventDefault();

			//get user access token
			let token = localStorage.getItem("token");

			//this.setState({loading:true});
			
			if((null !== this.state.imageString) && ("" !== this.state.imageString))
			{
				//make axios call to api
				try
				{

					let response = await axios({
						method: "post",
						url: "http://mofehintolumumuni.com/gitserver/api/users/profile/images/upload",
						data: {"photo": this.state.imageString},
						headers: {"Authorization": "Bearer "+token}
						});
	
						let status = response.data.status;
						let data = response.data.data;

						if(status === "success")
						{
							this.setState({imageState: data.image});
							this.setState({loading:false});
							alert(this.state.imageState);
							
						}
						else
						{
							alert("Image upload error!");
							this.setState({loading:false});
						}

				}catch(error)
				{
					alert("Image upload error!");
					this.setState({loading:false});
				}
				
			}
			else
			{
				alert("Select an image before uploading!");
				this.setState({loading:false});
			}
		}
		

		async deleteUser()
		{
		
			//get user access token
			let token = localStorage.getItem("token");

		try{

			this.setState({loading:true});

			let response = await axios({
				method: "delete",
				url: "http://mofehintolumumuni.com/gitserver/api/users/profile/delete",
				headers: {"Authorization": "Bearer "+token}
				});

				let status = response.data.status;
				let message = response.data.data.message;
			if(status === "success")
			{
				localStorage.setItem("token","noToken");
				alert(message);
				this.setState({loading:false});
				
				this.props.history.push("/gitsearch/");

			}else{
				alert(message);
				this.setState({loading:false});
			}
	
		}
		catch(error)
		{
			alert("Error Deleting profile!");
			this.setState({loading:false});
		}
		
	

		}



/*
	issueName: null,
				issueState: null,
				issueProgLang: null,
				typeName: null,
				type: null
*/


		handleIssueName(e)
		{
			this.setState({issueName:e.target.value});
		}
		handleIssueState(e)
		{
			this.setState({issueState:e.target.value});
		}
		
		handleProgLang(e)
		{
			this.setState({issueProgLang:e.target.value});
		}
		
		async handleSaveIssue(e)
		{
			e.preventDefault();

			//get user access token
			let token = localStorage.getItem("token");

			this.setState({loading:true});

			if((this.state.issueProgLang !== null) && (this.state.issueProgLang !== "") && (this.state.issueName !== null) && (this.state.issueName !== "") && (this.state.issueState !== null) && (this.state.issueState !== ""))
			{
				//make axios call
				try{
					let response = await axios({
						method: "post",
						url: "http://mofehintolumumuni.com/gitserver/api/users/preference/github/issueSearch/save",
						"data":{
						  issue: this.state.issueName,
						language: this.state.issueProgLang,
						state: this.state.issueState
						},
						headers: {"Authorization": "Bearer "+token}
					});

					let status = response.data.status;
					let message = response.data.data;

						if(status === "success")
						{
							alert("Github Issue data saved successfully!");
							this.setState({loading:false});
						}
						else
						{
							alert(`Github Issue data not saved successfully! ${message}`);
							this.setState({loading:false});
						}
				}
				catch(error)
				{
					alert("Github Issue not saved successfully!");
					this.setState({loading:false});
				}
			}
			else
			{
				alert("Fill Issue form properly before submitting!");
				this.setState({loading:false});
			}

		}



		handleTypeName(e)
		{
			this.setState({typeName:e.target.value});
		}

		handleType(e)
		{
			this.setState({type:e.target.value});
		}

		async handleTypeSubmit(e)
		{
			e.preventDefault();

			//get user access token
			let token = localStorage.getItem("token");

			this.setState({loading:true});

			var endPoint = null;
			
			//get type and select endpoint to query
			if((this.state.type !== null) && (this.state.type !== ""))
			{
				var dataPost = {};

				if(this.state.type === "organization")
				{
					endPoint = "/api/users/preference/github/repoSearch/save";
					dataPost = {
						orgname:this.state.typeName
						};
					
				}
				if(this.state.type === "user")
				{
					endPoint = "/api/users/preference/github/usersearch/save";
					 dataPost = {
						username:this.state.typeName
						};
					
				}

				


				if((this.state.typeName !== null) && (this.state.typeName !== ""))
				{	
					try{
							//make axios call
					let response = await axios({
						method: "post",
						url: `http://mofehintolumumuni.com/gitserver${endPoint}`,
						"data": dataPost,
						headers: {"Authorization": "Bearer "+token}
					});

					let status = response.data.status;
					let message = response.data.data;

						if(status === "success")
						{
							alert("Data saved successfully!");
							this.setState({loading:false});
						}
						else
						{
							alert(`Data not saved successfully! ${message}`);
							this.setState({loading:false});
						}
					}
					catch(error)
					{	
						alert("Data not saved successfully!");
						this.setState({loading:false});
					}
				

				}
				else
				{
					alert("Fill in Organization or Username before submitting form");
					this.setState({loading:false});
				}
			}
			else
			{
				alert("Select Organization or Username option before submitting form");
				this.setState({loading:false});
			}

			
		}


		async showUsers()
		{
			let link = "http://mofehintolumumuni.com/gitserver/api/users/preference/github/usersearch/show?page=1";


			//make axios call to show api
			try
			{
				this.setState({loading:true});
				//get user access token
			let token = localStorage.getItem("token");

				let userDataResponse = await axios({
					method: "get",
					url: `${link}`,
					headers: {"Authorization": "Bearer "+token}
					});

					if(userDataResponse.data.status === "success")
					{
						//alert(userDataResponse);
						this.setState({usersPayload:userDataResponse.data.data});
						this.setState({usersPayloadLinks:userDataResponse.data.links});
						this.setState({loading:false});
					}
					//alert(JSON.stringify(userDataResponse));
			}
			catch(error)
			{
				alert('Error loading data from Github server');
				this.setState({loading:false});
			}
		
		}

		async showIssues()
		{
			let link = "http://mofehintolumumuni.com/gitserver/api/users/preference/github/issueSearch/show?page=1";

			//make axios call to show api
			try
			{
				this.setState({loading:true});
				//get user access token
			let token = localStorage.getItem("token");

				let userDataResponse = await axios({
					method: "get",
					url: `${link}`,
					headers: {"Authorization": "Bearer "+token}
					});

					if(userDataResponse.data.status === "success")
					{
						this.setState({issuesPayload:userDataResponse.data.data});
						this.setState({issuesPayloadLinks:userDataResponse.data.links});
						this.setState({loading:false});
					}
	
			}
			catch(error)
			{
				alert('Error loading data from server');
				this.setState({loading:false});
			}
		}

		async showOrgs()
		{	
			let link = "http://mofehintolumumuni.com/gitserver/api/users/preference/github/repoSearch/show?page=1";
		
			//make axios call to show api
			try
			{ 	
				this.setState({loading:true});
				//get user access token
			let token = localStorage.getItem("token");	

					let userDataResponse = await axios({
					method: "get",
					url: `${link}`,
					headers: {"Authorization": "Bearer "+token}
					});

					let status = userDataResponse.data.status;
					let data = userDataResponse.data.data;
					let links = userDataResponse.data.links;
					
					//alert(JSON.stringify(links));
					if(status === "success")
					{
						//alert(JSON.stringify(userDataResponse.data));
						this.setState({orgsPayload: data});
						this.setState({orgsPayloadLinks: links});
						this.setState({loading:false});
					}
				//	alert(JSON.stringify(userDataResponse.data));
			}
			catch(error)
			{
				alert('Error loading data from server');
				this.setState({loading:false});
			}
		}

		
		async nextOrgs()
		{
			if(this.state.orgsPayloadLinks.LINKS_PRESENT === true)
			{
				let linkData = this.state.orgsPayloadLinks.LINKS_DATA;

				if(linkData.next_page_url !== null)
				{
					
					let link = linkData.next_page_url;
		
						//make axios call to show api
						try
						{ 	
							this.setState({loading:true});
							//get user access token
						let token = localStorage.getItem("token");	

								let userDataResponse = await axios({
								method: "get",
								url: `${link}`,
								headers: {"Authorization": "Bearer "+token}
								});

								let status = userDataResponse.data.status;
								let data = userDataResponse.data.data;
								let links = userDataResponse.data.links;
								

								if(status === "success")
								{
									//alert(JSON.stringify(userDataResponse.data));
									this.setState({orgsPayload: data});
									this.setState({orgsPayloadLinks: links});
									this.setState({loading:false});
								}
							//	alert(JSON.stringify(userDataResponse.data));
						}
						catch(error)
						{
							alert('Error loading data from server');
							this.setState({loading:false});
						}
				}
				
			}
		}
		
		
	  async prevOrgs()
	   {
			if(this.state.orgsPayloadLinks.LINKS_PRESENT === true)
			{
				let linkData = this.state.orgsPayloadLinks.LINKS_DATA;

				if(linkData.prev_page_url !== null)
				{
					let link = linkData.prev_page_url;
		
						//make axios call to show api
						try
						{ 	
							this.setState({loading:true});
							//get user access token
						let token = localStorage.getItem("token");	

								let userDataResponse = await axios({
								method: "get",
								url: `${link}`,
								headers: {"Authorization": "Bearer "+token}
								});

								let status = userDataResponse.data.status;
								let data = userDataResponse.data.data;
								let links = userDataResponse.data.links;
								

								if(status === "success")
								{
									//alert(JSON.stringify(userDataResponse.data));
									this.setState({orgsPayload: data});
									this.setState({orgsPayloadLinks: links});
									this.setState({loading:false});
								}
							//	alert(JSON.stringify(userDataResponse.data));
						}
						catch(error)
						{
							alert('Error loading data from server');
							this.setState({loading:false});
						}
				}
				
			}
	   }
	   
		
		async prevIssue()
		{
			if(this.state.issuesPayloadLinks.LINKS_PRESENT === true)
			{
				let linkData = this.state.issuesPayloadLinks.LINKS_DATA;

				if(linkData.prev_page_url !== null)
				{
					
					let link = linkData.prev_page_url;

						//make axios call to show api
						try
						{
							this.setState({loading:true});
							//get user access token
						let token = localStorage.getItem("token");

							let userDataResponse = await axios({
								method: "get",
								url: `${link}`,
								headers: {"Authorization": "Bearer "+token}
								});

								if(userDataResponse.data.status === "success")
								{
									this.setState({issuesPayload:userDataResponse.data.data});
									this.setState({issuesPayloadLinks:userDataResponse.data.links});
									this.setState({loading:false});
								}
				
						}
						catch(error)
						{
							alert('Error loading data from server');
							this.setState({loading:false});
						}
				}
				
			}
		}
		
		
		async nextIssue()
		{
			if(this.state.issuesPayloadLinks.LINKS_PRESENT === true)
			{
				let linkData = this.state.issuesPayloadLinks.LINKS_DATA;
				
				if(linkData.next_page_url !== null)
				{
					
					
					let link = linkData.next_page_url;

						//make axios call to show api
						try
						{
							this.setState({loading:true});
							//get user access token
						let token = localStorage.getItem("token");

							let userDataResponse = await axios({
								method: "get",
								url: `${link}`,
								headers: {"Authorization": "Bearer "+token}
								});
								
								if(userDataResponse.data.status === "success")
								{ 
									
									this.setState({issuesPayload:userDataResponse.data.data});
									this.setState({issuesPayloadLinks:userDataResponse.data.links});
									this.setState({loading:false});
								}
				
						}
						catch(error)
						{
							alert('Error loading data from server');
							this.setState({loading:false});
						}
				}
				
			}
		}
		
		async prevUsers()
		{
			if(this.state.usersPayloadLinks.LINKS_PRESENT === true)
			{
				let linkData = this.state.usersPayloadLinks.LINKS_DATA;

				if(linkData.prev_page_url !== null)
				{
					let link = linkData.prev_page_url;

					//make axios call to show api
					try
					{
						this.setState({loading:true});
						//get user access token
					let token = localStorage.getItem("token");

						let userDataResponse = await axios({
							method: "get",
							url: `${link}`,
							headers: {"Authorization": "Bearer "+token}
							});

							if(userDataResponse.data.status === "success")
							{
								//alert(userDataResponse);
								this.setState({usersPayload:userDataResponse.data.data});
								this.setState({usersPayloadLinks:userDataResponse.data.links});
								this.setState({loading:false});
							}
							//alert(JSON.stringify(userDataResponse));
					}
					catch(error)
					{
						alert('Error loading data from Github server');
						this.setState({loading:false});
					}
		
				}
				
			}
		}
		
		async nextUsers()
		{
			if(this.state.usersPayloadLinks.LINKS_PRESENT === true)
			{
				let linkData = this.state.usersPayloadLinks.LINKS_DATA;

				if(linkData.next_page_url !== null)
				{
					let link = linkData.next_page_url;

					//make axios call to show api
					try
					{
						this.setState({loading:true});
						//get user access token
					let token = localStorage.getItem("token");

						let userDataResponse = await axios({
							method: "get",
							url: `${link}`,
							headers: {"Authorization": "Bearer "+token}
							});

							if(userDataResponse.data.status === "success")
							{	
								//alert(userDataResponse);
								this.setState({usersPayload:userDataResponse.data.data});
								this.setState({usersPayloadLinks:userDataResponse.data.links});
								this.setState({loading:false});
							}
							//alert(JSON.stringify(userDataResponse));
					}
					catch(error)
					{
						alert('Error loading data from Github server');
						this.setState({loading:false});
					}
				}
				
			}
		}

		async logOut()
		{
			

				//get user access token
				let token = localStorage.getItem("token");
					
				if((token === "noToken") || (token === null))
				{
				alert("Ilegal page view");
				 this.props.history.push("/gitsearch/");
				}
	
				//make axios call to api
				try{
						let userDataResponse = await axios({
						method: "get",
						url: "http://mofehintolumumuni.com/gitserver/api/logout",
						headers: {"Authorization": "Bearer "+token}
						});
		
						let requestStatus = userDataResponse.data.status;
					
						let message = userDataResponse.data.message;
		
						if(requestStatus === "success")
						{
							localStorage.setItem("token","noToken");
							alert(message);
							this.props.history.push("/gitsearch/");
							
						}
						else{
						
							alert(message);
						}
				}
				catch(error)
				{
					alert("Logout not successful try again!");
				}
				

		}
		

	render()
	{
			var imageView;

		if(null == this.state.userImage)
		{
		 	imageView = "/home/mofehint/public_html/gitsearch/images/user-default.jpg"
		}
		else{
			imageView = `http://mofehintolumumuni.com/gitserver/images/userImages/${this.state.userImage}`;
		}

	return(
			<React.Fragment>
            <div className="container">
    	<ol className="breadcrumb" >
			  <li><a href="#">Dashboard</a></li>
			  
			  <li onClick={this.logOut}><Link to="#">Logout</Link></li>
			 
			</ol>
			
		
		</div>
		<br></br>
	 	<div className="container" >
			<div className="content">
			
		
				<div className="3-cols">
					<div className="col-1 col-md-3">
						
							<div className="user-profile1 text-center" >
							<form onSubmit={this.uploadImage} >
                            <img id="image_selecter" src={imageView}  alt="Profile" />
							

                            <br>
						
								</br>
								<p>To upload your avatar select an image and wait for it to be uploaded.</p>
								<br>
						
						</br>
								<input id="picture" name="profileimage" type="file" onChange={this.changeImage} />
							
                                <br>
								</br>

							
								</form>
								
														
							</div>
						
						</div>
						
					</div>
					
					<div className="col-md-6 col-3">
							<div className="col-3-grid-3 alert-box" >
							
							<h3 id="deacttext" >Hello <span ><strong>{this.state.firstName}</strong></span></h3>
							<br>
								</br>
							<strong>
							<p ><i className="fa fa-chevron-right"></i> Welcome to <strong >gitSearch</strong></p>
							{(null === this.state.firstName) ? <p ><i className="fa fa-chevron-right" ></i> You have not updated your personal details e.g: Firstname. Click on Account settings to do so!</p> : null}
								
							<p ><i className="fa fa-chevron-right" ></i> This application allows you to store Github usernames, organization usernames, and issues.</p>
							<p ><i className="fa fa-chevron-right" ></i> Use the forms below to store your prefered Github usernames, organization usernames, and issues .</p>
							<p ><i className="fa fa-chevron-right" ></i> You would get search results for repository information, events, gists etc... directly from Github once you store Github usernames, organization usernames, and issues.</p>
							<p ><i className="fa fa-chevron-right"></i> Please note that in the cause of using this application any latency experienced would be as a result of slow response from GITHUB SERVERS!</p></strong>
						</div>

					</div>
					
					
					<div className="col-3 col-md-3">
					
						<div className="chat-box">
							<div className="people-on-chat">
							<h3 className="text-center" ><strong>My Account</strong></h3>
							<br>
								</br>
								<p><i className="fa fa-cogs" ></i> <a href="#" id="accountset" data-toggle="modal" data-target="#infoModal">Account Settings</a></p>
								{(this.state.emailVerificationStatus) ? null : <p onClick={this.handleClick}><i className="fa fa-at"></i> <a href="#">Resend Account confirmation mail.</a></p>}
								<p onClick={this.deleteUser}><i className="fa fa-times-circle" ></i><a href="#"> Deactivate Account</a></p>
								
								<br>
								</br>
								<h3 className="text-center"><strong>My Information</strong></h3>
								<br>
								</br>
								<p><i className="fa fa-chevron-right"></i> First name : {this.state.firstName}</p>
								<p><i className="fa fa-chevron-right"></i> Last name : {this.state.lastName}</p>
								
								<p><i className="fa fa-chevron-right"></i> Middle name : {this.state.middleName}</p>
								
							</div>
						
						</div>
												
						</div>
						
						</div>
						</div>


	<div className="total-ads main-grid-border">
		<div className="container">
			<div className="select-box">
				
			
				<div className="clearfix"></div>
			</div>
			


			<div className="ads-grid">
				<div className="side-bar col-md-3">
					<form onSubmit={this.handleTypeSubmit}>
                    <h3 className="sear-head"><strong>Save User name or Organization name</strong></h3>
					<div className="brand-select">
						<h4 className="sear-head">Select preference</h4>
						  <select className="selectpicker" data-live-search="true" onChange={this.handleType} >
						  <option value="">Select option</option>
						  <option value="user">User</option>
						  <option value="organization">Organization</option>
				
						</select>
					</div>
					
					<div className="search-hotel">
					<h4 className="sear-head">User name or Organization name</h4>
					
						<input type="text" placeholder="Enter name..."  onChange={this.handleTypeName}/>
						<input  type="submit" value="GO" /> 
				
                   
					</div>
                     </form>
					 <br></br>
					 <br></br>
				
            
				<form onSubmit={this.handleSaveIssue}>
                <h3 className="sear-head"><strong>Save Github Issue</strong></h3>
					<div className="brand-select">
						<h4 className="sear-head">Select Programming Language</h4>
						  <select className="selectpicker" data-live-search="true" onChange={this.handleProgLang}>
						  <option value="">CHOOSE LANGUAGE</option>
						  <option value="php">PHP</option>
						  <option values="javascript">JAVASCRIPT</option>
						  <option value="c-sharp">C-SHARP</option>
						  <option value="python">PYTHON</option>
						  <option value="dart">DART</option>
						  <option value="delphi">Delphi</option>
						  <option value="elixir">ELIXIR</option>
						  <option value="erlang">ERLANG</option>
						  <option value="hack">HACK</option>
						  <option value="kotlin">KOTLIN</option>
						  <option value="lua">LUA</option>
						  <option value="rust">RUST</option>
						  <option value="typescript">TYPESCRIPT</option>
						  <option value="unrealscript">UNREALSCRIPT</option>
						  <option value="C">C</option>
						  <option value="C++">C++</option>
						  <option value="GO">GO</option>
						  <option value="ruby">RUBY</option>
						  <option value="java">JAVA</option>
						  <option value="solidity">SOLIDITY</option>
						  <option value="swift">SWIFT</option>
						  <option value="r">R</option>
						  <option value="objective-c">OBJECTIVE-C</option>
						  <option value="sql">SQL</option>
						  <option value="haskel">HASKEL</option>
						  <option value="powershell">POWERSHELL</option>
						  <option value="fortran">FORTRAN</option>
				
						</select>
					</div>
                    
                    <div className="brand-select">
						<h4 className="sear-head">Select issue state</h4>
						  <select className="selectpicker" data-live-search="true" onChange={this.handleIssueState}>
						  <option value="">Select option</option>
						  <option value="open">Open</option>
						  <option value="closed">Closed</option>
						</select>
					</div>
					
					<div className="search-hotel">
					<h4 className="sear-head">Enter Issue</h4>
					
						<input type="text" placeholder="Enter Issue..." onChange={this.handleIssueName}/>
						<input  type="submit" value="GO" /> 
					
					</div>
					</form>
					</div>


				<div className="ads-display col-md-9">
				{(this.state.loading) ? <h3>Loading data from Server <i className="fa fa-cogs" ></i> </h3> : null}
					<div className="wrapper">				
					<p>Click the tabs below to view your saved data</p>	
					<div className="bs-example bs-example-tabs" role="tabpanel" data-example-id="togglable-tabs">
					  <ul id="myTab" className="nav nav-tabs nav-tabs-responsive" role="tablist">
						<li role="presentation" className="active">
						  <a href="#home" id="home-tab" role="tab" data-toggle="tab" aria-controls="home" onClick={this.showUsers} aria-expanded="true">
							<span className="text">Users</span>
						  </a>
						</li>
						<li role="presentation" className="next">
						  <a href="#profile" role="tab" id="profile-tab" data-toggle="tab"  onClick={this.showOrgs} aria-controls="profile">
							<span className="text">Organizations</span>
						  </a>
						</li>
						<li role="presentation">
						  <a href="#samsa" role="tab" id="samsa-tab" data-toggle="tab" onClick={this.showIssues} aria-controls="samsa">
							<span className="text">Issues</span>
						  </a>
						</li>
					  </ul>
					  
	
	
					  <div id="myTabContent" className="tab-content">
						<div role="tabpanel" className="tab-pane fade in active" id="home" aria-labelledby="home-tab">
						   <div>
												<div id="container">
							
								<div className="clearfix"></div>
							<ul className="list">
	
				{(this.state.usersPayload.length > 0) ? <Usersloopcomponent data={this.state.usersPayload}/> : null}
				
							</ul>
						</div>
							</div>

						{(this.state.usersPayloadLinks.LINKS_PRESENT) ? <p> page {this.state.usersPayloadLinks.LINKS_DATA.current_page} of {this.state.usersPayloadLinks.LINKS_DATA.last_page} </p>: null}

							<ul className="pagination pagination-sm">
							<li onClick={this.prevUsers}><Link to="#">Prev </Link></li>
				
							<li onClick={this.nextUsers}><Link to="#"> Next </Link></li>
						</ul>
						</div>


						<div role="tabpanel" className="tab-pane fade" id="profile" aria-labelledby="profile-tab">
						 <div>
												<div id="container">
								
								<div className="clearfix"></div>
							<ul className="list">
							{(this.state.orgsPayload.length > 0) ? <Orgsloopcomponent data={this.state.orgsPayload}/> : null}
								
							</ul>
						</div>
							</div>

							{(this.state.orgsPayloadLinks.LINKS_PRESENT) ? <p> page {this.state.orgsPayloadLinks.LINKS_DATA.current_page} of {this.state.orgsPayloadLinks.LINKS_DATA.last_page} </p> : null}

							<ul className="pagination pagination-sm">
							<li onClick={this.prevOrgs}><Link to="#">Prev </Link></li>
				
							<li onClick={this.nextOrgs}><Link to="#"> Next </Link></li>
						</ul>
						</div>


						<div role="tabpanel" className="tab-pane fade" id="samsa" aria-labelledby="samsa-tab">
						  <div>
												<div id="container">
								
								<div className="clearfix"></div>
							<ul className="list">
							{(this.state.issuesPayload.length > 0) ? <Issueloopcomponent data={this.state.issuesPayload}/> : null}
							
								
							</ul>
						</div>
							</div>

						{(this.state.issuesPayloadLinks.LINKS_PRESENT) ? <p> page {this.state.issuesPayloadLinks.LINKS_DATA.current_page} of {this.state.issuesPayloadLinks.LINKS_DATA.last_page} </p> : null}

							<ul className="pagination pagination-sm">
							<li onClick={this.prevIssue}><Link to="#">Prev </Link></li>
				
							<li onClick={this.nextIssue}><Link to="#"> Next </Link></li>
						</ul>
						</div>
						
					  </div>
					</div>
				</div>
				</div>
				<div className="clearfix"></div>
			</div>
		</div>	
	</div>
</React.Fragment>

	);
	}


    }
    



    export default dashboardComponent;


